// Station/channel path segments, shared by every storage layer that addresses data by
// station: envelope tile keys, event doc ids, and the OPFS raw-data cache.
/**
 * Constructs the path prefix for a given station.
 * Format: {network}_{station}
 */
export function getStationPrefix(station) {
    return `${station.network}_${station.station}`;
}
/**
 * Inverse of getStationPrefix: "{network}_{station}" → { network, station }.
 */
export function parseStationPrefix(prefix) {
    const sep = prefix.indexOf("_");
    if (sep < 0)
        return undefined;
    const network = prefix.slice(0, sep);
    const station = prefix.slice(sep + 1);
    if (!network || !station)
        return undefined;
    return { network, station };
}
/** Encode a SEED location code as a path segment. Blank (undefined or "") becomes "--". */
export function encodeLocation(location) {
    return location ? location : "--";
}
/** Inverse of encodeLocation: "--" becomes "". */
export function decodeLocation(segment) {
    return segment === "--" ? "" : segment;
}
/**
 * Constructs the path prefix for a given station, location, and channel.
 * Format: {network}_{station}/{location}/{channel}
 */
export function getStationChannelPrefix(stationData) {
    const { channel, location } = stationData;
    return `${getStationPrefix(stationData)}/${encodeLocation(location)}/${channel}`;
}
export function getLevelPrefix(stationData) {
    return `${getStationChannelPrefix(stationData)}/L`;
}
export function getLevelPath(stationData, level) {
    return `${getLevelPrefix(stationData)}${level}`;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGlvbi1hZGRyZXNzaW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc2hhcmVkL3NlaXNtaWMvc3RhdGlvbi1hZGRyZXNzaW5nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLHNGQUFzRjtBQUN0RiwyRUFBMkU7QUFFM0U7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLGdCQUFnQixDQUFDLE9BQWtCO0lBQ2pELE9BQU8sR0FBRyxPQUFPLENBQUMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQztBQUNqRCxDQUFDO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsa0JBQWtCLENBQUMsTUFBYztJQUMvQyxNQUFNLEdBQUcsR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2hDLElBQUksR0FBRyxHQUFHLENBQUM7UUFBRSxPQUFPLFNBQVMsQ0FBQztJQUU5QixNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUNyQyxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUMsQ0FBQztJQUN0QyxJQUFJLENBQUMsT0FBTyxJQUFJLENBQUUsT0FBTztRQUFFLE9BQU8sU0FBUyxDQUFDO0lBRTVDLE9BQU8sRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDOUIsQ0FBQztBQUVELDJGQUEyRjtBQUMzRixNQUFNLFVBQVUsY0FBYyxDQUFDLFFBQWlCO0lBQzlDLE9BQU8sUUFBUSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztBQUNwQyxDQUFDO0FBRUQsa0RBQWtEO0FBQ2xELE1BQU0sVUFBVSxjQUFjLENBQUMsT0FBZTtJQUM1QyxPQUFPLE9BQU8sS0FBSyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDO0FBQ3pDLENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsdUJBQXVCLENBQUMsV0FBd0I7SUFDOUQsTUFBTSxFQUFFLE9BQU8sRUFBRSxRQUFRLEVBQUUsR0FBRyxXQUFXLENBQUM7SUFDMUMsT0FBTyxHQUFHLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyxJQUFJLGNBQWMsQ0FBQyxRQUFRLENBQUMsSUFBSSxPQUFPLEVBQUUsQ0FBQztBQUNuRixDQUFDO0FBRUQsTUFBTSxVQUFVLGNBQWMsQ0FBQyxXQUF3QjtJQUNyRCxPQUFPLEdBQUcsdUJBQXVCLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQztBQUNyRCxDQUFDO0FBRUQsTUFBTSxVQUFVLFlBQVksQ0FBQyxXQUF3QixFQUFFLEtBQWE7SUFDbEUsT0FBTyxHQUFHLGNBQWMsQ0FBQyxXQUFXLENBQUMsR0FBRyxLQUFLLEVBQUUsQ0FBQztBQUNsRCxDQUFDIn0=